<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/73Momo/tc-custom/9780830843831.jpg?1696374748497" alt="This image is the cover for the book The Soul of Wine"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Soul of Wine
      </h1>
      <p class="bookDescription body article font2">
        <p> <strong>★ Publishers Weekly starred review</strong> </p> <p> <strong>Wine is a wonderful, lavish, and mysterious gift from God.</strong> </p> <p>Gisela Kreglinger, the daughter of a vintner and trained as a theologian, invites us to discover wine as part of a more full-bodied Christian spirituality. She shows us how the soulful savoring of wine is God's way of wooing us back into a great love affair. Indeed, Jesus' first miracle was turning water into wine at a wedding. Along with bread, wine is the gift we receive at the table of communion. Through these gifts we experience God's glorious and loving presence among us, feeding and nurturing us in body, soul, and spirit.</p> <p>Wine was never meant just for a small and elite group of well-to-do people but is for us all. Wine can reenchant the world and help us fall in love with it all over again. Come and savor its goodness. A wine tasting and book discussion guide is also included.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gisela H. Kreglinger
      </h2>
      
      <p class="authorDescription body article"><p>Gisela H. Kreglinger (PhD, St. Andrews) grew up on a winery in Franconia, Germany, where her family has been crafting wine for many generations. She holds a PhD in historical theology from the University of St. Andrews and taught Christian spirituality at Samford University before turning to writing full time. She is a public speaker and leads people on wine pilgrimages in France and Germany. Kreglinger is also the author of <em>The Spirituality of Wine</em>.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b57caddc